export default function () {
  const accordions = document.querySelectorAll(
    ".foundations-explorer__repeater-wrapper",
  );

  accordions.forEach((accordion, accordionIndex) => {
    const items = accordion.querySelectorAll(
      ".foundations-explorer__repeater-item",
    );

    items.forEach((item, itemIndex) => {
      const trigger = getTrigger(item);
      const panel = getPanel(item);

      if (!trigger || !panel) return;

      const id = `foundations-explorer-${accordionIndex + 1}-${itemIndex + 1}`;

      trigger.id = `${id}__trigger`;
      panel.id = `${id}__panel`;
      trigger.setAttribute("aria-controls", panel.id);
      panel.setAttribute("aria-labelledby", trigger.id);
      panel.setAttribute("role", "region");

      const isOpen = item.classList.contains("is-open");

      trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
      panel.style.maxHeight = isOpen ? "none" : "0px";

      // Listening on the item makes the whole card clickable. Clicks on the
      // button bubble up to here too, so this stays a single handler.
      item.addEventListener("click", (event) => {
        if (panel.contains(event.target)) return; // Let people read/select open content
        if (
          event.target.closest(
            "a, button:not(.foundations-explorer__repeater-item-trigger)",
          )
        )
          return;
        if (hasTextSelection()) return;

        toggleItem(item);
      });

      panel.addEventListener("transitionend", (event) => {
        if (event.propertyName !== "max-height") return;
        if (item.classList.contains("is-open")) {
          panel.style.maxHeight = "none"; // Let open panels grow with their content
        }
      });
    });

    window.addEventListener("resize", () => {
      refreshOpenPanels(items);
    });
  });

  // Each item opens and closes on its own — siblings are left untouched
  function toggleItem(item) {
    if (item.classList.contains("is-open")) {
      closeItem(item);
      return;
    }

    openItem(item);
  }

  function openItem(item) {
    const trigger = getTrigger(item);
    const panel = getPanel(item);

    if (!trigger || !panel) return;

    item.classList.add("is-open");
    trigger.setAttribute("aria-expanded", "true");
    panel.style.maxHeight = `${panel.scrollHeight}px`;
  }

  function closeItem(item) {
    const trigger = getTrigger(item);
    const panel = getPanel(item);

    if (!trigger || !panel) return;
    if (!item.classList.contains("is-open")) return;

    panel.style.maxHeight = `${panel.scrollHeight}px`; // Swap "none" for a real value first

    requestAnimationFrame(() => {
      item.classList.remove("is-open");
      trigger.setAttribute("aria-expanded", "false");
      panel.style.maxHeight = "0px";
    });
  }

  function refreshOpenPanels(items) {
    items.forEach((item) => {
      const panel = getPanel(item);

      if (panel && item.classList.contains("is-open")) {
        panel.style.maxHeight = "none";
      }
    });
  }

  function hasTextSelection() {
    const selection = window.getSelection();

    return selection && selection.toString().length > 0;
  }

  function getTrigger(item) {
    return item.querySelector(".foundations-explorer__repeater-item-trigger");
  }

  function getPanel(item) {
    return item.querySelector(".foundations-explorer__repeater-item-hidden");
  }
}
